import http from 'plugins/axios';

export default {
  getList(data) {
    return http.get({
      url: '/la/admin/lever/record',
      data
    });
  },
  getSum(data) {
    return http.get({
      url: '/la/admin/lever/sum',
      data
    });
  },
  create(data) {
    return http.post({
      url: '/la/admin/lever/add',
      data,
      dataType: 'form'
    });
  },
  update(data) {
    return http.post({
      url: '/la/admin/lever/update',
      data,
      dataType: 'form'
    });
  },
  getCoinTypeList() {
    return http.get({
      url: '/la/admin/coin/allDisplay'
    });
  },
  getAllpair() {
    return http.get({
      url: '/la/admin/pair/list'
    });
  },
  createTest(data) {
    return http.post({
      url: '/la/admin/current/test/addLock',
      data,
      dataType: 'form'
    });
  }
};
